/**
 * Query-param plumbing for region scoping.
 *
 * Kept apart from `api.ts` on purpose: `client.ts` appends region scope to
 * every request it builds, and `api.ts` imports `client.ts` — importing this
 * from either one is free of that cycle.
 */

/** The key every region-scoped request uses. `[]` makes Plug read an array. */
export const REGION_IDS_PARAM = "region_ids[]";

/**
 * Add the active region selection to a set of query params.
 *
 * An absent or empty selection means "all regions", and emits NOTHING: the
 * request must come out identical to one built by a caller that has never
 * heard of regions, so a fleet without regions is unaffected.
 *
 * @returns the same `searchParams`, for chaining
 */
export function appendRegionIds(
  searchParams: URLSearchParams,
  regionIds?: readonly string[] | null,
): URLSearchParams {
  if (!regionIds || regionIds.length === 0) {
    return searchParams;
  }

  for (const regionId of regionIds) {
    searchParams.append(REGION_IDS_PARAM, regionId);
  }

  return searchParams;
}
